import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

//-- =============================================
//    --Author: <Author,, Name>
//--Create date: <Create Date,, >
//    -- Description:	<Description,,>
//    -- exec TMA_GetDemonstratorTraining 202419, 202422, 14
//    -- =============================================
//    Alter PROCEDURE TMA_GetDemonstratorTraining
//    @FromWeek int,
//    @ToWeek int,
//    @ShipId int
//    AS
//    BEGIN
//    -- SET NOCOUNT ON added to prevent extra result sets from
//    -- interfering with SELECT statements.
//    SET NOCOUNT ON;

//    -- Insert statements for procedure here
//    With CTE_Training
//    As (
//    Select Distinct Sf.SFId, MobiTrainingResults.TrainingDate, MobiTrainingResults.Result, MobiTrainingType.training_type, WeekId as TrainingWeek
//    from Sf
//    inner join MobiTrainingResults on SF.SFId = MobiTrainingResults.SfId
//    inner join MobiTrainingType on MobiTrainingResults.TrainId = MobiTrainingType.MobiTrainingTypeId
//    Where SF.StartWeekId Between @FromWeek and @ToWeek
//    ),
//    CTE_Manager as(
//    Select Unit.UnitId,SF.SFId,SF.FirstNames + ' ' + SF.Surname AS 'ManagerName',SFCurrentCode AS 'ManagerCode' FROM Unit
//    Inner Join SF ON Unit.SfId = Sf.SfId),
//    Cte_Status as (
//    Select * from (
//    Select a.RecruitedById, Status.StatusCode1 +''+ Status.StatusCode2 as RecruiterStatus
//    , ROW_NUMBER() over (partition by Sfhistory.sfid order by sfhistory.weekid desc) as RNum
//    from (
//    Select Distinct RecruitedById
//    From SF
//    inner join SFHistory on SF.SFId = SFHistory.SFId
//    Where Sf.StartWeekId between @FromWeek and @ToWeek
//    --Where SF.SFId = 4747839
//    ) a
//    inner join SFHistory on a.RecruitedById = SFHistory.SFId and SFHistory.WeekId <= @ToWeek
//    inner join Status on SFHistory.StatusId = Status.StatusId
//    ) b
//    Where b.RNum = 1
//    )

//    Select isnull(convert(nvarchar(50), CTE_Training.TrainingDate), '-') as TrainingDate, isnull(CTE_Training.Result, '-') as TrainingResult
//    , isnull(CTE_Training.training_type, '-') as TrainingType, Sf.SFId, sf.StartWeekId, Unit.UnitCode, Unit.UnitName, CTE_Manager.ManagerName, CTE_Manager.ManagerCode
//    , SFHistory.RecruitedById, sf.SFCurrentCode, sf.FirstNames+' '+sf.Surname as sfName, sf.TelephoneCell, sf.SMSQueryCell as registerdCell
//    , ROW_NUMBER() over (partition by sfhistory.sfid order by sfhistory.weekid) as RNum
//    , Unit.UnitId
//    , Status.StatusCode1+Status.StatusCode2 as Status,
//    isnull(JourneyType,'None') as JourneyType,
//    --	   Team.TeamId ,Team.TeamCode,Team.TeamName,
//    Case
//    WHEN Recruit.Channel = 1 then 'Mobi'
//    WHEN Recruit.Channel = 2 then 'Ecommerce'
//    WHEN Recruit.Channel = 3 then 'Self Register'
//    ELSE 'Traditional'
//    END As Channel
//    , convert(date, Sf.RecordCreated) as DateJoined,
//    TeamUnits.TeamId,
//    Team.TeamName, isnull(convert(nvarchar(10), CTE_Training.TrainingWeek), '-') as TrainingWeek
//    from sf
//    inner join Week on sf.StartWeekId = Week.WeekId
//    inner join Segment on Week.PeriodId = Segment.PeriodId
//    inner join SFHistory on sf.SFId = SFHistory.SFId and SFHistory.WeekId = sf.StartWeekId
//    inner join Status on SFHistory.StatusId = Status.StatusId
//    inner join Unit on SFHistory.UnitId = Unit.UnitId
//    Left Join TeamUnits on Unit.UnitId = TeamUnits.UnitId and TeamUnits.StartWeekId <= @ToWeek and (TeamUnits.EndWeekId is null or TeamUnits.EndWeekId >= @ToWeek)
//    inner join ShipZone on Unit.ShipZoneId = ShipZone.ShipZoneId
//    Left join team on TeamUnits.TeamId = team.TeamId
//    Left Join CTE_Training on CTE_Training.SFId = SF.SFId
//    Left Join CTE_Manager on CTE_Manager.UnitId = Unit.UnitId
//    Left Join RecruitContactDetails on SF.SFId = RecruitContactDetails.SfId and RecruitContactDetails.IsLastContact = 1 or RecruitContactDetails.IsLastContact is null
//    Left Join RecruitContactStatus on RecruitContactDetails.RecruitContactStatusId = RecruitContactStatus.RecruitContactStatusId
//    Left Join SFjourney on SFJourney.SFJourneyId = SF.JourneyId
//    Left join Recruit on SFHistory.SFId = Recruit.SfId
//    Where Sf.StartWeekId between @FromWeek and @ToWeek and ShipZone.ShipId = @ShipId
//    order by SfId, training_type
//    END
//    GO


export default class DemonstratorTrainingReport extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getDemonstratorTraining = this.getDemonstratorTraining.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentDidMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 1)

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getDemonstratorTraining() {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/demonstrator/getdemonstratortraining?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
            let demRecs = [];
            let rec;
            response.data.map((dem) => {
                rec = {
                    unitCode: dem.unitCode,
                    unitName: dem.unitName,
                    sfCurrentCode: dem.sfCurrentCode,
                    sfName: dem.sfName,
                    registerdCell: dem.registerdCell,
                    status: dem.status,
                    startWeekId: dem.startWeekId,
                    Channel: dem.channel,
                    DateJoined: dem.dateJoined,
                    TrainingDate: dem.trainingDate,
                    TrainingWeek: dem.trainingWeek,
                    TrainingType: dem.trainingType,
                    TrainingResult: dem.trainingResult,

                }
                demRecs.push(rec);
            });
            let tableData = {
                columns: [{
                    label: 'Unit Code',
                    field: 'unitCode'
                }, {
                    label: 'Unit Name',
                    field: 'unitName'
                }, {
                    label: 'New Recruit Code',
                    field: 'sfCurrentCode'
                }, {
                    label: 'New Recruit Name',
                    field: 'sfName'
                }, {
                    label: 'Registered Cell',
                    field: 'registerdCell'
                }, {
                    label: 'Status',
                    field: 'status'
                }, {
                    label: 'Start Week',
                    field: 'startWeekId'
                }, {
                    label: 'Channel',
                    field: 'Channel'
                }, {
                    label: 'Date Joined',
                    field: 'DateJoined'
                }, {
                    label: 'Training Date',
                    field: 'TrainingDate'
                    }, {
                    label: 'Training Week',
                    field: 'TrainingWeek'
                    }, {
                    label: 'Training Type',
                    field: 'TrainingType'
                }, {
                    label: 'Training Result',
                    field: 'TrainingResult'
                }



                ],
                rows: demRecs
            }
            this.setState({
                teamData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {

        return (
            <div>
                <Header headerText='Demonstrator Training Report'
                    subHeaderText="(Click Go to load detailed report for selected weeks)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol>
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="From Week..."
                                                options={this.state.fromWeekData}
                                                selected="Filter"
                                                getValue={this.handleFromSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="To Week..."
                                                options={this.state.toWeekData}
                                                selected="Filter"
                                                getValue={this.handleToSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getDemonstratorTraining}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>

                            {/*<MDBCol md="6">*/}
                            {/*    <MDBContainer>*/}
                            {/*        <DashboardLineGraph chartName="Team Sales Performance" graphData={this.state.teamGraphData} />*/}
                            {/*    </MDBContainer>*/}
                            {/*</MDBCol>*/}
                        </MDBRow>

                        <br />

                        <div hidden={this.state.tableHidden}>
                            <hr />
                            <MDBContainer>
                                <MDBRow>
                                    <span style={{ fontWeight: "bold" }}>Detailed Recruit Results<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</span>
                                </MDBRow>

                            </MDBContainer>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                hover
                                data={this.state.teamData}
                                paging={false}
                                autoWidth
                            />;

                        </div>
                    </MDBCardBody>
                </MDBCard>
            </div>
        );
    }


}
